/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Headline_1Inputs */

const et_hero_headline_1 = /** @type {(inputs: Hero_Headline_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tõstame Teie ettevõtte `)
};

const en_hero_headline_1 = /** @type {(inputs: Hero_Headline_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We increase your business `)
};

/**
* | output |
* | --- |
* | "We increase your business" |
*
* @param {Hero_Headline_1Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const hero_headline_1 = /** @type {((inputs?: Hero_Headline_1Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Headline_1Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_hero_headline_1(inputs)
	return en_hero_headline_1(inputs)
});